<template>
  <header class="bb-header">
    <div class="bb-header-inner">
      <div class="bb-header-left" ref="navLeft">
        <a class="bb-logo" @click.prevent="gopage('/')">
          <BrandLogo />
        </a>
        <nav class="bb-nav" ref="navEl" v-if="!isShowNav">
          <div
            v-for="(item, index) in displayNavList"
            :key="index"
            class="bb-nav-item"
            :class="{ active: isNavActive(item), 'bb-nav-more': item.children && item.children.length }"
            @click="onNavClick(item)"
          >
            <span class="bb-nav-label">
              <svg v-if="item.icon === 'fire'" class="bb-nav-fire" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.73536 1.94434C6.84938 1.56745 7.0304 1.46509 7.52443 1.81153C9.358 3.09075 10.4757 4.64618 10.8779 6.47754C10.9421 6.77887 11.2252 6.78253 11.2988 6.47754C11.4048 6.0388 11.4551 5.58773 11.4492 5.13575C11.4493 4.7687 11.7313 4.76901 11.9248 5.03614C15.1501 10.3024 12.1574 13.8977 9.70021 14.3857C9.32859 14.4589 9.16906 14.2441 9.16896 13.8369C9.16896 12.6365 8.57268 11.5289 7.65821 10.8066C7.33648 10.5518 7.17367 10.6488 7.19728 11.0205C7.28278 12.3722 6.99832 13.3982 6.34279 14.0977C6.15362 14.3368 5.82284 14.399 5.56349 14.2441C1.71195 12.1544 2.04285 7.90241 4.5547 5.26367C6.00364 3.73631 6.53821 2.58481 6.73536 1.94434Z"
                  fill="currentColor"
                />
              </svg>
              {{ item.name }}
            </span>
            <svg v-if="item.children && item.children.length" class="bb-caret" width="14" height="14" viewBox="0 0 16 16" fill="none">
              <path d="M8.00017 8.78077L11.3 5.48096L12.2428 6.42376L8.00017 10.6664L3.75757 6.42376L4.70037 5.48096L8.00017 8.78077Z" fill="currentColor" />
            </svg>
            <div class="bb-more-menu" v-if="item.children && item.children.length">
              <div
                class="bb-more-item"
                v-for="child in item.children"
                :key="child.path"
                :class="{ active: $route.path === child.path }"
                @click.stop="gopage(child.path)"
              >
                {{ child.name }}
              </div>
            </div>
          </div>
        </nav>
        <nav class="bb-nav bb-nav-measure" ref="navMeasure" aria-hidden="true">
          <div class="bb-nav-item" v-for="(item, index) in navList" :key="'m-' + index">
            <span class="bb-nav-label">{{ item.name }}</span>
            <svg v-if="item.children && item.children.length" class="bb-caret" width="14" height="14" viewBox="0 0 16 16" fill="none">
              <path d="M8.00017 8.78077L11.3 5.48096L12.2428 6.42376L8.00017 10.6664L3.75757 6.42376L4.70037 5.48096L8.00017 8.78077Z" fill="currentColor" />
            </svg>
          </div>
        </nav>
      </div>
      <div class="bb-header-right">
        <!-- <div class="bb-search-wrap" v-if="!isShowNav">
          <span class="bb-icon-btn" @click="toggleSearch">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path fill="currentColor" d="m17.874 16.46 4.283 4.283-1.414 1.414-4.283-4.283a8.96 8.96 0 0 1-5.617 1.97c-4.968 0-9-4.033-9-9 0-4.969 4.032-9 9-9s9 4.031 9 9a8.96 8.96 0 0 1-1.969 5.616m-2.006-.742a6.98 6.98 0 0 0 1.975-4.875c0-3.867-3.132-7-7-7s-7 3.133-7 7 3.133 7 7 7a6.98 6.98 0 0 0 4.875-1.975z" />
            </svg>
          </span>
          <div class="bb-search-panel" v-if="searchShow" @click.stop>
            <input v-model="searchQuery" type="text" :placeholder="$t('souSuo')" />
            <div class="bb-search-item" v-for="item in filteredMarketList" :key="item.id" @click="goToMarket(item)">
              <span>{{ item.appName || item.code }}</span>
              <em>{{ item.nowPrice }}</em>
            </div>
            <div class="bb-search-empty" v-if="searchQuery.trim() && !filteredMarketList.length">{{ $t("toast.nothingfound") }}</div>
          </div>
        </div> -->
        <div class="bb-actions" v-if="!isLogin && !isShowNav">
          <button class="bb-btn ghost" type="button" @click="$router.push(authEntryPath)">
            {{ $t("navTab.btnLogin") }}
          </button>
          <button class="bb-btn brand" type="button" @click="$router.push(signupPath)">
            {{ $t("navTab.btnSignup") }}
          </button>
        </div>
        <template v-else-if="isLogin && !isShowNav">
          <span class="bb-split" v-if="!isLogin && !isShowNav"></span>
          <button class="bb-btn brand sm" type="button" @click="gopage('/profile/deposit')">{{ $t("chongZhi") }}</button>
          <div class="bb-nav-item bb-nav-more">
            <span>{{ $t("navTab.assets") }}</span>
            <svg class="bb-caret" width="14" height="14" viewBox="0 0 16 16" fill="none">
              <path d="M8.00017 8.78077L11.3 5.48096L12.2428 6.42376L8.00017 10.6664L3.75757 6.42376L4.70037 5.48096L8.00017 8.78077Z" fill="currentColor" />
            </svg>
            <div class="bb-more-menu">
              <div class="bb-more-item" @click.stop="gopage('/profile/balance')">{{ $t("home.overview") }}</div>
              <div class="bb-more-item" @click.stop="gopage('/profile/deposit')">{{ $t("chongZhi") }}</div>
              <div class="bb-more-item" @click.stop="gopage('/profile/withdraw')">{{ $t("tiXian") }}</div>
            </div>
          </div>
          <div class="bb-nav-item bb-nav-more" :class="{ active: isOrderNavActive }" @click="gopage('/profile?tab=orders')">
            <span>{{ $t("account.order") }}</span>
            <svg class="bb-caret" width="14" height="14" viewBox="0 0 16 16" fill="none">
              <path d="M8.00017 8.78077L11.3 5.48096L12.2428 6.42376L8.00017 10.6664L3.75757 6.42376L4.70037 5.48096L8.00017 8.78077Z" fill="currentColor" />
            </svg>
            <div class="bb-more-menu">
              <div class="bb-more-item" @click.stop="gopage('/profile?tab=orders')">{{ $t("account.order") }}</div>
            </div>
          </div>
          <span class="bb-split"></span>
          <div class="bb-nav-item bb-nav-more bb-user">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill="currentColor" d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM6.02332 15.4163C7.49083 17.6069 9.69511 19 12.1597 19C14.6243 19 16.8286 17.6069 18.2961 15.4163C16.6885 13.9172 14.5312 13 12.1597 13C9.78821 13 7.63095 13.9172 6.02332 15.4163ZM12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z" />
            </svg>
            <div class="bb-user-menu">
              <div class="bb-user-card">
                <div class="bb-user-name">{{ maskAccount }}</div>
                <div class="bb-user-uid">UID: {{ userId }}</div>
              </div>
              <div class="bb-more-item" @click.stop="gopage('/profile')">{{ $t("home.overview") }}</div>
              <div class="bb-more-item" @click.stop="gopage('/profile/invite')">{{ $t("account.inviteFriends") }}</div>
            </div>
          </div>
          <span class="bb-icon-btn" @click="gopage('/profile/notification')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path fill="currentColor" d="M20 16.5H22V18.5H2V16.5H4V9.5C4 5.08172 7.58172 1.5 12 1.5C16.4183 1.5 20 5.08172 20 9.5V16.5ZM18 16.5V9.5C18 6.18629 15.3137 3.5 12 3.5C8.68629 3.5 6 6.18629 6 9.5V16.5H18ZM9 20.5H15V22.5H9V20.5Z" />
            </svg>
          </span>
        </template>
        <ThemeSwitch />
        <div class="bb-lang" id="myModal">
          <span class="bb-icon-btn" @click="openLanguage()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                fill="currentColor"
                d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.01 8.01 0 0 0 5.648 6.667M10.03 13c.151 2.439.848 4.73 1.97 6.752A15.9 15.9 0 0 0 13.97 13zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.01 8.01 0 0 0 19.938 13M4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.01 8.01 0 0 0 4.062 11m5.969 0h3.938A15.9 15.9 0 0 0 12 4.248 15.9 15.9 0 0 0 10.03 11m4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.01 8.01 0 0 0-5.648-6.667"
              />
            </svg>
          </span>
          <div class="bb-lang-panel" v-if="isLanguage">
            <div class="bb-lang-title">{{ $t("navTab.language") }}</div>
            <div class="bb-lang-grid">
              <div
                class="bb-lang-item"
                :class="{ active: langIndex == index }"
                @click="langChange(index)"
                v-for="(item, index) in langList"
                :key="index"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { openCustomerService } from "@/utils/customerService";
import { getAuthEntryPath, getSignupPath } from "@/utils/authRedirect";
import { listMarketByType } from "@/api/market.js";
import BrandLogo from "@/components/BrandLogo.vue";
import ThemeSwitch from "@/components/ThemeSwitch.vue";

export default {
  name: "NavPc",
  components: { BrandLogo, ThemeSwitch },
  data() {
    return {
      isLanguage: false,
      searchShow: false,
      searchQuery: "",
      marketList: [],
      marketListLoading: false,
      navOverflowCount: 0
    };
  },
  props: {
    title: {
      type: String,
      default: "IC Markets"
    }
  },
  computed: {
    ...mapState(["footerWhiteList"]),
    ...mapGetters(["langList", "langIndex", "getUserInfo", "getMarkTypeList"]),
    isLogin() {
      return this.$store.state.isLogin;
    },
    currentRouteName() {
      return this.$route.name;
    },
    isShowNav() {
      return this.footerWhiteList.includes(this.currentRouteName);
    },
    authEntryPath() {
      return getAuthEntryPath();
    },
    signupPath() {
      return getSignupPath();
    },
    userId() {
      const info = this.getUserInfo || {};
      return info.id || "";
    },
    maskAccount() {
      const info = this.getUserInfo || {};
      const raw = String(info.email || info.userName || info.account || info.id || "");
      if (raw.includes("@")) {
        const parts = raw.split("@");
        const name = parts[0];
        const keep = name.slice(0, 2);
        return keep + "*****" + (name.length > 2 ? name.slice(-1) : "") + "@" + parts[1];
      }
      if (raw.length > 6) return raw.slice(0, 2) + "*****" + raw.slice(-1);
      return raw;
    },
    filteredMarketList() {
      const query = (this.searchQuery || "").trim().toLowerCase();
      if (!query) return [];
      return this.marketList.filter((item) => {
        return [item.appName, item.name, item.code].some((field) => {
          return field != null && String(field).toLowerCase().includes(query);
        });
      });
    },
    navList() {
      return [
        // { name: this.$t("home.buyCoin"), path: "/tokenSale" },
        { name: this.$t("navTab.tabMenu2"), path: "/market" },
        { name: this.$t("navTab.smartContract"), path: "/trading" },
        {
          name: this.$t("navTab.trade"),
          path: "/trade/futures",
          children: [
            { name: this.$t("Market.options"), path: "/trade/options" },
            { name: this.$t("Market.contracts"), path: "/trade/futures" }
          ]
        },
        { name: this.$t("tokenSale.title"), path: "/tokenSale" },
        { name: this.$t("account.inviteFriends"), path: "/profile/invite" },
        {
          name: this.$t("navTab.tabMenuMore"),
          path: "/nfts",
          children: [
            { name: this.$t("ntfs.NFTs"), path: "/nfts" },
            { name: this.$t("navTab.lending"), path: "/loan" },
            { name: this.$t("navTab.tabMenu7"), path: "/profile" }
          ]
        }
      ];
    },
    displayNavList() {
      const list = this.navList || [];
      if (!list.length) return [];
      const more = list[list.length - 1];
      const primary = list.slice(0, -1);
      const hide = Math.min(Math.max(this.navOverflowCount, 0), primary.length);
      const keep = primary.length - hide;
      const hidden = primary.slice(keep);
      const extra = [];
      hidden.forEach((item) => {
        extra.push({ name: item.name, path: item.path });
        (item.children || []).forEach((child) => {
          if (child.path !== item.path) extra.push(child);
        });
      });
      return [
        ...primary.slice(0, keep),
        {
          name: more.name,
          path: more.path,
          children: extra.concat(more.children || [])
        }
      ];
    },
    currentPath() {
      return "/" + this.$route.path.split("/")[1];
    },
    isOrderNavActive() {
      const path = (this.$route.path || "").replace(/\/+$/, "") || "/";
      return path === "/profile" && String(this.$route.query.tab || "") === "orders";
    }
  },
  mounted() {
    this.$nextTick(() => {
      const that = this;
      const modal = document.getElementById("myModal");
      document.addEventListener("click", function (event) {
        if (modal && event.target !== modal && !modal.contains(event.target)) {
          that.closeModal();
        }
      });
      this.bindNavOverflow();
    });
  },
  beforeDestroy() {
    if (this._navRo) {
      this._navRo.disconnect();
      this._navRo = null;
    }
    window.removeEventListener("resize", this.updateNavOverflow);
  },
  watch: {
    langIndex() {
      this.$nextTick(this.updateNavOverflow);
    },
    isShowNav() {
      this.$nextTick(this.bindNavOverflow);
    }
  },
  methods: {
    openService() {
      openCustomerService(this);
    },
    langChange(index) {
      let lang = this.langList[index].value;
      this.closeModal();
      this.$store.commit("SET_LANG", lang);
      this.$store.dispatch("listContents", lang == "zh" ? 1 : 2);
    },
    closeModal() {
      this.isLanguage = false;
    },
    openLanguage() {
      this.isLanguage = !this.isLanguage;
    },
    navPathMatch(path, target) {
      if (!target) return false;
      if (target === "/profile/invite") {
        return path === "/profile/invite" || path.startsWith("/profile/invite/");
      }
      if (target === "/profile") {
        if (this.$route.query.tab === "orders") return false;
        return path === "/profile" || path === "/profile/";
      }
      return path === target || path.startsWith(target + "/");
    },
    isNavActive(item) {
      const path = this.$route.path;
      const childPaths = (item.children || []).map((c) => c.path);
      if (childPaths.some((p) => this.navPathMatch(path, p))) return true;
      return this.navPathMatch(path, item.path);
    },
    onNavClick(item) {
      if (item.children && item.children.length) return;
      this.gopage(item.path);
    },
    gopage(url) {
      this.searchShow = false;
      if (typeof url !== "string") {
        this.$router.push(url, () => {});
        return;
      }
      const qIndex = url.indexOf("?");
      if (qIndex === -1) {
        this.$router.push({ path: url, query: {} }, () => {});
        return;
      }
      const path = url.slice(0, qIndex);
      const query = {};
      url.slice(qIndex + 1).split("&").forEach((pair) => {
        if (!pair) return;
        const eq = pair.indexOf("=");
        const key = decodeURIComponent(eq === -1 ? pair : pair.slice(0, eq));
        const val = decodeURIComponent(eq === -1 ? "" : pair.slice(eq + 1));
        if (key) query[key] = val;
      });
      this.$router.push({ path, query }, () => {});
    },
    toggleSearch() {
      this.searchShow = !this.searchShow;
      if (this.searchShow) this.loadAllMarkets();
      else this.searchQuery = "";
    },
    async loadAllMarkets() {
      if (this.marketListLoading || this.marketList.length > 0) return;
      this.marketListLoading = true;
      try {
        const types = (this.getMarkTypeList || []).map((t) => t.value);
        const responses = await Promise.all(types.map((type) => listMarketByType({ type })));
        const map = new Map();
        responses.forEach((res) => {
          (res.result || []).forEach((item) => {
            if (!map.has(item.id)) {
              map.set(item.id, {
                ...item,
                nowPrice: item.price,
                zdf: item.zdf != null ? (item.zdf * 100).toFixed(2) : "0.00"
              });
            }
          });
        });
        this.marketList = Array.from(map.values());
      } catch (e) {
        this.marketList = [];
      } finally {
        this.marketListLoading = false;
      }
    },
    bindNavOverflow() {
      this.updateNavOverflow();
      if (this._navRo) {
        this._navRo.disconnect();
        this._navRo = null;
      }
      window.removeEventListener("resize", this.updateNavOverflow);
      if (!this.$refs.navEl) return;
      if (typeof ResizeObserver === "undefined") {
        window.addEventListener("resize", this.updateNavOverflow);
        return;
      }
      this._navRo = new ResizeObserver(() => this.updateNavOverflow());
      this._navRo.observe(this.$refs.navEl);
      if (this.$refs.navLeft) this._navRo.observe(this.$refs.navLeft);
    },
    updateNavOverflow() {
      const nav = this.$refs.navEl;
      const measure = this.$refs.navMeasure;
      if (!nav || !measure) return;
      const available = Math.max(0, nav.clientWidth - 8);
      const items = measure.children;
      if (!items.length) return;
      const gap = 28;
      const moreW = items[items.length - 1].offsetWidth;
      let used = 0;
      let keep = 0;
      for (let i = 0; i < items.length - 1; i++) {
        const next = items[i].offsetWidth + gap;
        if (used + next + moreW > available) break;
        used += next;
        keep += 1;
      }
      const hide = items.length - 1 - keep;
      if (this.navOverflowCount !== hide) this.navOverflowCount = hide;
    },
    goToMarket(item) {
      this.searchShow = false;
      this.searchQuery = "";
      this.$router.push({
        path: "/trade/futures",
        query: { code: item.code, type: item.type, id: item.id }
      });
    }
  }
};
</script>
<style scoped>
.bb-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  height: 64px;
  background: var(--bb-bg);
  border-bottom: 1px solid var(--bb-divider, var(--bb-divider));
  color: var(--bb-text);
  font-size: 16px;
  line-height: 1;
}
.bb-header-inner {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 24px;
  min-width: 0;
  overflow: visible;
}
.bb-header-left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
  height: 100%;
  overflow: visible;
  position: relative;
}
.bb-logo {
  display: inline-flex;
  align-items: center;
  height: 100%;
  margin-right: 24px;
  color: var(--bb-text);
  cursor: pointer;
  flex-shrink: 0;
}
.bb-nav {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 28px;
  flex: 1;
  min-width: 0;
  flex-wrap: nowrap;
}
.bb-nav-measure {
  position: absolute;
  left: -9999px;
  top: 0;
  height: 64px;
  overflow: hidden;
  visibility: hidden;
  pointer-events: none;
  flex: none;
  gap: 28px;
}
.bb-nav-item {
  height: 100%;
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: var(--bb-text);
  cursor: pointer;
  white-space: nowrap;
}
.bb-nav-label {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}
.bb-nav-fire {
  color: #fc5b6f;
  flex-shrink: 0;
}
.bb-nav-item:hover,
.bb-nav-item.active {
  color: var(--bb-brand);
}
.bb-nav-more {
  position: relative;
  gap: 2px;
}
.bb-caret {
  color: var(--bb-text-tertiary);
  flex-shrink: 0;
  transition: transform 0.2s;
}
.bb-nav-more:hover .bb-caret {
  transform: rotate(180deg);
  color: var(--bb-brand);
}
.bb-more-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  min-width: 140px;
  padding: 8px 0;
  background: var(--bb-bg-elevated);
  border: 1px solid var(--bb-border);
  border-radius: 10px;
  box-shadow: var(--bb-shadow);
  z-index: 2000;
}
.bb-more-menu::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: -12px;
  height: 12px;
}
.bb-nav-more:hover .bb-more-menu,
.bb-nav-more:focus-within .bb-more-menu {
  display: block;
}
.bb-more-item {
  padding: 10px 16px;
  color: var(--bb-text-tertiary);
  font-size: 14px;
  cursor: pointer;
}
.bb-more-item:hover,
.bb-more-item.active {
  color: var(--bb-text);
}
.bb-header-right {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  flex-shrink: 0;
  height: 100%;
}
.bb-lang {
  position: relative;
  color: var(--bb-text);
  font-size: 14px;
  height: 24px;
}
.bb-lang-btn {
  cursor: pointer;
}
.bb-lang-panel {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  min-width: 280px;
  padding: 16px;
  background: var(--bb-bg-elevated);
  border: 1px solid var(--bb-border);
  border-radius: 12px;
  z-index: 30;
}
.bb-lang-title {
  font-size: 13px;
  color: var(--bb-text-tertiary);
  margin-bottom: 12px;
}
.bb-lang-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.bb-lang-item {
  padding: 8px 12px;
  border-radius: 20px;
  cursor: pointer;
  color: var(--bb-text);
  font-size: 13px;
}
.bb-lang-item.active,
.bb-lang-item:hover {
  background: var(--bb-brand);
  color: var(--bb-always-black);
}
.bb-actions {
  display: flex;
  gap: 8px;
}
.bb-btn {
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.bb-btn.ghost {
  background: transparent;
  color: var(--bb-text);
}
.bb-btn.ghost:hover {
  color: var(--bb-brand);
}
.bb-btn.brand {
  background: var(--bb-brand);
  color: var(--bb-always-black);
}
.bb-btn.brand.sm {
  height: 32px;
  min-width: 56px;
  padding: 0 12px;
  border-radius: 8px;
}
.bb-split {
  width: 1px;
  height: 16px;
  background: var(--bb-divider);
}
.bb-icon-btn {
  display: inline-flex;
  color: var(--bb-text);
  cursor: pointer;
}
.bb-icon-btn:hover {
  color: var(--bb-brand);
}
.bb-search-wrap {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}
.bb-search-panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 340px;
  max-height: 500px;
  overflow: auto;
  background: var(--bb-bg-elevated);
  border: 1px solid var(--bb-border);
  border-radius: 12px;
  padding: 16px;
  z-index: 40;
}
.bb-search-panel input {
  width: 100%;
  height: 40px;
  border: 0;
  border-radius: 8px;
  background: var(--bb-bg-input);
  color: var(--bb-text);
  padding: 0 12px;
  outline: none;
  margin-bottom: 8px;
}
.bb-search-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 4px;
  cursor: pointer;
  font-size: 14px;
}
.bb-search-item em {
  font-style: normal;
  color: var(--bb-text-tertiary);
}
.bb-search-empty {
  color: var(--bb-text-tertiary);
  font-size: 13px;
  padding: 12px 0;
  text-align: center;
}
.bb-header-right .bb-nav-item {
  gap: 2px;
}
.bb-user {
  padding: 0 4px;
}
.bb-user-menu {
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  transform: none;
  min-width: 240px;
  padding: 12px;
  background: var(--bb-bg-elevated);
  border: 1px solid var(--bb-border);
  border-radius: 12px;
  box-shadow: var(--bb-shadow);
  z-index: 20;
}
.bb-user:hover .bb-user-menu {
  display: block;
}
.bb-user-card {
  padding: 8px 4px 12px;
  border-bottom: 1px solid var(--bb-divider);
  margin-bottom: 8px;
}
.bb-user-name {
  font-size: 16px;
  font-weight: 700;
}
.bb-user-uid {
  margin-top: 4px;
  font-size: 12px;
  color: var(--bb-text-tertiary);
}
.bb-btn.brand:hover {
  background: var(--bb-brand-hover);
}
</style>
